import React, { useContext } from 'react'

import { Dropdown, ModalContext } from '@sketch/components'
import { RenameShareModal } from '@sketch/modules-common'
import { ReactComponent as RenameIcon } from '@sketch/icons/text-edit-17'

interface RenameActionProps {
  id: string
  name: string
}

const RenameAction: React.FCC<RenameActionProps> = ({ id, name, children }) => {
  const { showModal } = useContext(ModalContext)

  return (
    <Dropdown.Item
      icon={<RenameIcon />}
      onClick={() => {
        showModal(RenameShareModal, {
          id,
          name,
        })
      }}
    >
      {children}
    </Dropdown.Item>
  )
}

export default RenameAction
